import { render } from "./TallClock.vue?vue&type=template&id=2b1bb73a&scoped=true"
import script from "./TallClock.vue?vue&type=script&lang=js"
export * from "./TallClock.vue?vue&type=script&lang=js"

import "./TallClock.vue?vue&type=style&index=0&id=2b1bb73a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1bb73a"]])

export default __exports__